export default __webpack_public_path__ + "static/media/Napoleonic-Blue.09ba197d.jpg";